/** Official bot for alerts (subscribe with /start after login; admin approves in Telegram Admin). */
export const TELEGRAM_BOT_URL = 'https://t.me/ayc_industries_bot';
export const TELEGRAM_BOT_LABEL = 't.me/ayc_industries_bot';
